export function CriticalityClass({ systemId, criticalityClass, distanceToNextClass, mtt, tD24, referenceValidated }) {
  return (
    <div className="space-y-3" data-testid={`criticality-class-${systemId}`}>
      <div className="flex items-center gap-2">
        <span className="text-[10px] uppercase tracking-widest text-[var(--oim-text-dim)] font-heading">Criticality Class</span>
        <span className="font-mono-data text-xl font-bold text-[var(--oim-text)]">{criticalityClass}</span>
        {!referenceValidated && <span className="text-[10px]" style={{ color: "var(--oim-gold)" }}>⚠ prototype values</span>}
      </div>
      <div className="text-[11px] text-[var(--oim-text-muted)] font-mono-data">
        Distance to class {Math.min(5, criticalityClass + 1)} — {distanceToNextClass} K of accumulation-driven rise
      </div>
      <div className="flex items-center gap-1">
        {[1, 2, 3, 4, 5].map((c) => (
          <div key={c} className="flex-1 flex flex-col items-center gap-1">
            <div
              className="w-full h-1.5 rounded-full"
              style={{ backgroundColor: c === criticalityClass ? "#FF3B30" : "var(--oim-surface-softer)" }}
            />
            <span className="text-[9px] font-mono-data" style={{ color: c === criticalityClass ? "var(--oim-text)" : "var(--oim-text-dim)" }}>{c}</span>
          </div>
        ))}
      </div>
      <div className="text-[10px] font-mono-data text-[var(--oim-text-muted)] space-y-0.5">
        <div>MTT {mtt} °C <span className="text-[var(--oim-text-dim)]">(configured, unvalidated)</span></div>
        <div>T_D24 {tD24} °C <span className="text-[var(--oim-text-dim)]">(configured, unvalidated)</span></div>
      </div>
    </div>
  );
}
